(function(){
var I={
es:{hours:'Brunch hasta las 4 pm','ley.pop':'Lo mas pedido','ley.veg':'Vegetariano','ley.nuts':'Contiene frutos secos','nav.title':'Menu',
't.metodos':'Metodos','t.cafes':'Cafes','t.destacados':'Destacados','t.compartir':'Compartir','t.brunch':'Brunch','t.panaderia':'Panaderia','t.adiciones':'Adiciones','t.bebidas':'Bebidas','t.alcohol':'Alcoholicas','t.postres':'Postres','t.perros':'Mascotas',
'cat.metodos':'Metodos de filtrado','cat.cafes':'Cafes','cat.destacados':'Destacados','cat.compartir':'Para compartir','cat.brunch':'Brunch','cat.panaderia':'Panaderia','cat.adiciones':'Adiciones','cat.bebidas':'Bebidas','cat.alcohol':'Bebidas alcoholicas','cat.postres':'Postres','cat.perros':'Helados para mascotas',
'note.metodos':'Doble $14,000 · El grano cambia cada semana','tp':'Lo mas pedido','tv':'Veg','tn':'Nueces','tnw':'Nuevo',
'wk.badge':'Recien llegado','wk.rot':'· Cafe exotico de la semana','wk.proc':'Proceso','wk.taza':'Taza','wk.doble':'Doble','wk.var':'Variedades','wk.frag':'Fragancia','wk.sab':'Sabor','wk.acid':'Acidez','wk.body':'Cuerpo','wk.fin':'Residual','wk.foot':'Preparalo en V60, Chemex, Aeropress o Prensa Francesa.'},
en:{hours:'Brunch until 4 pm','ley.pop':'Most ordered','ley.veg':'Vegetarian','ley.nuts':'Contains nuts','nav.title':'Menu',
't.metodos':'Methods','t.cafes':'Coffee','t.destacados':'Highlights','t.compartir':'To Share','t.brunch':'Brunch','t.panaderia':'Bakery','t.adiciones':'Extras','t.bebidas':'Drinks','t.alcohol':'Alcoholic','t.postres':'Desserts','t.perros':'Mascotas',
'cat.metodos':'Brewing Methods','cat.cafes':'Coffee','cat.destacados':'Highlights','cat.compartir':'To Share','cat.brunch':'Brunch','cat.panaderia':'Bakery','cat.adiciones':'Extras','cat.bebidas':'Drinks','cat.alcohol':'Alcoholic Drinks','cat.postres':'Desserts','cat.perros':'Helados para mascotas',
'note.metodos':'Double $14,000 · New bean every week','tp':'Most ordered','tv':'Veg','tn':'Nuts','tnw':'New',
'wk.badge':'Just landed','wk.rot':'· Exotic coffee of the week','wk.proc':'Process','wk.taza':'Cup','wk.doble':'Double','wk.var':'Varieties','wk.frag':'Fragrance','wk.sab':'Flavor','wk.acid':'Acidity','wk.body':'Body','wk.fin':'Aftertaste','wk.foot':'Brewed as V60, Chemex, Aeropress or French Press.'}
};
var lang='es';
var items=[].slice.call(document.querySelectorAll('.nz-item'));
var allLinks=[].slice.call(document.querySelectorAll('.nz-nav a,.nz-tabs-mob a'));
var tNodes=[].slice.call(document.querySelectorAll('[data-i18n]'));
var btnES=document.getElementById('btn-es');
var btnEN=document.getElementById('btn-en');
// Inyectar bg-image en photo-hover
items.forEach(function(it){
 var img=it.getAttribute('data-img');
 var ph=it.querySelector('.nz-photo-hover');
 if(img&&ph) ph.style.backgroundImage='url('+img+')';
});
// Observer
var obs=new IntersectionObserver(function(entries){
 entries.forEach(function(e){
 if(e.isIntersecting){
 allLinks.forEach(function(l){l.classList.remove('active');});
 document.querySelectorAll('.nz-nav a[href="#'+e.target.id+'"],.nz-tabs-mob a[href="#'+e.target.id+'"]').forEach(function(l){l.classList.add('active');});
 }
 });
},{rootMargin:'-15% 0px -75% 0px'});
document.querySelectorAll('.nz-cat').forEach(function(s){obs.observe(s);});
function tags(it,l){
 var t=[];
 var sec=it.closest('.nz-cat')?it.closest('.nz-cat').id:'';
 var food=['brunch','panaderia','postres','destacados','compartir'].indexOf(sec)>-1;
 if(it.dataset.popular==='true') t.push({c:'',tx:I[l].tp});
 if(food&&it.dataset.veg==='true') t.push({c:'veg',tx:I[l].tv});
 if(food&&it.dataset.nuts==='true') t.push({c:'',tx:I[l].tn});
 if(it.dataset.new==='true') t.push({c:'',tx:I[l].tnw});
 return t;
}
function renderItem(it,l){
 var isR=it.classList.contains('rich');
 var nm=it.dataset['name'+(l==='es'?'Es':'En')]||'';
 var ds=it.dataset['desc'+(l==='es'?'Es':'En')]||'';
 var pr=it.dataset.price||'';
 var ne=it.querySelector('.nz-name');
 ne.textContent=nm;
 it.querySelector('.nz-price').textContent=pr;
 if(isR){var de=it.querySelector('.nz-desc');if(de)de.textContent=ds;}
 ne.querySelectorAll('.nz-tag').forEach(function(t){t.remove();});
 tags(it,l).forEach(function(t){
 var el=document.createElement('span');
 el.className='nz-tag'+(t.c?' '+t.c:'');
 el.textContent=t.tx;
 ne.appendChild(el);
 });
}
// ══════ CAFE DE LA SEMANA · sigue el idioma de la carta ══════
var wk=document.querySelector('.nz-week');
if(wk){ // foto opcional: data-img en la tarjeta
 var wkImg=wk.getAttribute('data-img')||'';
 var wkPh=wk.querySelector('.nz-week-photo');
 if(wkImg&&wkPh){wkPh.style.backgroundImage='url('+wkImg+')';wk.classList.add('has-img');}
}
function renderWeek(l){
 if(!wk)return;
 var S=l==='es'?'Es':'En',d=wk.dataset;
 wk.querySelector('.nz-week-name').textContent=d['name'+S]||'';
 var o=wk.querySelector('.nz-week-orig');
 o.textContent=d['orig'+S]||'';o.style.display=d['orig'+S]?'':'none';
 var pv=d['proc'+S]||'';
 wk.querySelector('.nz-week-proc').textContent=pv;
 wk.querySelector('.nz-week-cproc').style.display=pv?'':'none';
 wk.querySelectorAll('.nz-week-f').forEach(function(f){
 var v=d[f.dataset.k+S]||'';
 f.querySelector('.nz-week-l').textContent=I[l]['wk.'+f.dataset.k]||'';
 f.querySelector('.nz-week-v').textContent=v;
 f.style.display=v?'':'none';
 });
}
function setLang(l){
 lang=l;
 btnES.setAttribute('aria-pressed',l==='es');
 btnEN.setAttribute('aria-pressed',l==='en');
 tNodes.forEach(function(n){var k=n.dataset.i18n;if(I[l][k]!=null)n.textContent=I[l][k];});
 items.forEach(function(it){renderItem(it,l);});
 renderWeek(l);
}
btnES.addEventListener('click',function(){setLang('es');});
btnEN.addEventListener('click',function(){setLang('en');});
setLang('es');
// Modal
var modal=document.getElementById('nzM');
var mP=document.getElementById('nzMP');
var mS=document.getElementById('nzMS');
var mT=document.getElementById('nzMT');
var mTG=document.getElementById('nzMTG');
var mD=document.getElementById('nzMD');
var mPR=document.getElementById('nzMPR');
var mX=document.getElementById('nzX');
function openModal(it){
 var l=lang;
 var h2=it.closest('.nz-cat')?it.closest('.nz-cat').querySelector('h2'):null;
 mS.textContent=h2?h2.textContent:'';
 mT.textContent=it.dataset['name'+(l==='es'?'Es':'En')]||'';
 mD.textContent=it.dataset['desc'+(l==='es'?'Es':'En')]||'';
 mPR.textContent=it.dataset.price||'';
 mTG.innerHTML='';
 tags(it,l).forEach(function(t){
 var el=document.createElement('span');
 el.className='nz-tag'+(t.c?' '+t.c:'');
 el.textContent=t.tx;
 mTG.appendChild(el);
 });
 var img=it.getAttribute('data-img')||'';
 if(img){mP.style.backgroundImage='url('+img+')';mP.style.display='block';}
 else{mP.style.display='none';}
 modal.setAttribute('aria-hidden','false');
 document.body.style.overflow='hidden';
 mX.focus();
}
function closeModal(){modal.setAttribute('aria-hidden','true');document.body.style.overflow='';}
mX.addEventListener('click',closeModal);
modal.addEventListener('click',function(e){if(e.target===modal)closeModal();});
document.addEventListener('keydown',function(e){if(e.key==='Escape')closeModal();});
var st;
window.addEventListener('scroll',function(){
 if(modal.getAttribute('aria-hidden')==='false'){clearTimeout(st);st=setTimeout(closeModal,150);}
});
items.forEach(function(it){
 var btn=it.querySelector('.nz-open');
 if(!btn)return;
 btn.addEventListener('click',function(){openModal(it);});
 it.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();btn.click();}});
});
document.documentElement.style.scrollBehavior='smooth';
})();
